import { useMutation } from '@apollo/client';
import { CREATE_REQUEST_SPACE_MUTATION } from '@/app/auth/_store/mutation/graphql/mutation.graphql.ts';

export function useCreateRequestSpace() {
  return useMutation(CREATE_REQUEST_SPACE_MUTATION);
}
